module.exports = __webpack_public_path__ + "img/3.441323e2.jpg";